import React, { useState } from "react";
import {
    CardElement,
    useStripe,
    useElements
} from "@stripe/react-stripe-js";
import API from "../../api/axios";
import {useNavigate , useParams} from "react-router-dom";
const CARD_ELEMENT_OPTIONS = {
    style: {
        base: {
            fontSize: "16px",
            color: "#32325d",
            "::placeholder": {
                color: "#aab7c4",
            },
        },
        invalid: {
            color: "#fa755a",
            iconColor: "#fa755a",
        },
    },
    hidePostalCode: true,
};

const CreditCardForm = ({ id, setError }) => {
    const stripe = useStripe();
    const elements = useElements();
    const [processing, setProcessing] = useState(false);
    const [message, setMessage] = useState("");
    const [succeeded, setSucceeded] = useState(false);
    const navigate = useNavigate();
    const handleSubmit = async (e) => {
        e.preventDefault();
        setProcessing(true);
        setMessage("");

        try {
            const { data } = await API.post("/create-card-checkout", {
                id: id, // or pass dynamic user ID
                amount: 500 // 5 GBP, adjust as needed
            });

            const result = await stripe.confirmCardPayment(data.client_token, {
                payment_method: {
                    card: elements.getElement(CardElement),
                },
            });

            if (result.error) {
                //setMessage(result.error.message);
                setMessage("You must use a credit card to prove you are over the age of 18, or we can not verify you.");

            } else {
                if (result.paymentIntent.status === "succeeded") {
                    setSucceeded(true);
                    setMessage("✅ Payment succeeded!");
                    navigate("/paymentverified/" + id);

                }
            }
        } catch (error) {
            setMessage("❌ Payment failed. Try again.");
            console.error(error);
        } finally {
            setProcessing(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} className="bg-white p-6 rounded-xl shadow-md space-y-4 max-w-md mx-auto">
            <h2 className="text-xl font-bold text-[#652F9B] text-center">Credit Card Verification</h2>

            <div className="border border-gray-300 p-4 rounded-md">
                <CardElement options={CARD_ELEMENT_OPTIONS} />
            </div>

            <button
                type="submit"
                disabled={!stripe || processing}
                className="w-full bg-[#8E29CD] text-white py-2 px-4 rounded-lg hover:bg-[#6c1aa1] transition-colors"
            >
                {processing ? "Processing..." : "Verify Now"}
            </button>

            {message && (
                <div className={`text-sm text-center font-medium ${succeeded ? "text-green-600" : "text-red-500"}`}>
                    {message}
                </div>
            )}
        </form>
    );
};

export default CreditCardForm;
